.form {
  display: flex;
  flex-direction: column;
  gap: var(--space-6);
}

.grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--space-4) var(--space-5);
}

.colHalf {
  grid-column: span 2;
}

.colFull {
  grid-column: span 2;
}

@media (min-width: 720px) {
  .colHalf {
    grid-column: span 1;
  }
}

.field {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

.labelRow {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: var(--space-3);
  min-height: 20px;
}

.label {
  font-size: 13px;
  font-weight: 600;
  letter-spacing: -0.01em;
  color: var(--text);
}

.hint {
  font-size: 12px;
  color: var(--text-subtle);
  font-family: var(--font-mono);
}

.errorMsg {
  font-size: 12px;
  color: var(--danger);
  font-weight: 500;
}

.input,
.select,
.textarea {
  width: 100%;
  padding: 12px 14px;
  background: var(--bg-elevated);
  color: var(--text);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  font: inherit;
  line-height: 1.4;
  transition: border-color var(--dur-base) var(--ease-out),
    background var(--dur-base) var(--ease-out),
    box-shadow var(--dur-base) var(--ease-out);
}

.textarea {
  min-height: 140px;
  resize: vertical;
  font-family: var(--font-sans);
}

.select {
  appearance: none;
  -webkit-appearance: none;
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8' fill='none'><path d='M1 1l5 5 5-5' stroke='%23a1a8b5' stroke-width='1.8' stroke-linecap='round' stroke-linejoin='round'/></svg>");
  background-repeat: no-repeat;
  background-position: right 14px center;
  padding-right: 38px;
}

.input::placeholder,
.textarea::placeholder {
  color: var(--text-subtle);
}

.input:hover,
.select:hover,
.textarea:hover {
  border-color: var(--border-strong);
}

.input:focus-visible,
.select:focus-visible,
.textarea:focus-visible {
  outline: none;
  border-color: var(--accent);
  box-shadow: var(--ring);
  background: var(--bg-elevated);
}

.fieldError .input,
.fieldError .select,
.fieldError .textarea {
  border-color: var(--danger);
  background: var(--danger-soft);
}

.fieldError .input:focus-visible,
.fieldError .select:focus-visible,
.fieldError .textarea:focus-visible {
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--danger) 35%, transparent);
}

.honeypot {
  position: absolute;
  left: -10000px;
  top: auto;
  width: 1px;
  height: 1px;
  overflow: hidden;
}

.turnstile {
  /* min-height: 65px; */
  display: flex;
  align-items: center;
  justify-content: start;
  width: 1px;
}

@media only screen and (max-width: 400px) {
  .turnstile {
    transform: scale(0.85);
  }
}

@media only screen and (max-width: 320px) {
  .turnstile {
    transform: scale(0.70);
  }
}

.turnstile[data-ready='false'] {
  /* min-height: 65px; */
  background: color-mix(in srgb, var(--surface-subtle) 60%, transparent);
  border-radius: 8px;
}



.footer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-4);
  padding-top: var(--space-4);
  border-top: 1px dashed var(--border);
}

.submit[data-status='success'] {
  background: var(--success) !important;
  color: #fff !important;
  border-color: color-mix(in srgb, var(--success) 70%, #000 20%) !important;
  cursor: default;
}

.submit[data-status='submitting'] {
  cursor: progress;
}

.privacy {
  max-width: 48ch;
  font-size: 12.5px;
  color: var(--text-subtle);
  margin: 0;
}

.statusRegion {
  min-height: 0;
  font-size: 14px;
  padding: 0;
  border-radius: var(--radius-sm);
  color: var(--text-muted);
  transition: all var(--dur-base) var(--ease-out);
}

.statusRegion:empty {
  display: none;
}

.statusRegion[data-status='error'] {
  padding: 12px 14px;
  background: var(--danger-soft);
  color: var(--danger);
  border: 1px solid color-mix(in srgb, var(--danger) 25%, transparent);
}

.statusRegion[data-status='success'] {
  padding: 12px 14px;
  background: var(--success-soft);
  color: var(--success);
  border: 1px solid color-mix(in srgb, var(--success) 25%, transparent);
}

.statusRegion[data-status='submitting'] {
  padding: 12px 14px;
  background: var(--surface);
  color: var(--text-muted);
  border: 1px solid var(--border);
}
